export const getErrorMessage = (message, t) => {
	if (message === "Invalid or expired token")
		return (t("authentication.validation.forgot_password-expired"));
	if (message.includes("too_short"))
		return (t("authentication.validation.password-too-short"));
	if (message.includes("insufficient_uppercase"))
		return (t("authentication.validation.password-insufficient-uppercase"));
	if (message.includes("insufficient_digit"))
		return (t("authentication.validation.password-insufficient-digit"));
	if (message.includes("insufficient_special"))
		return (t("authentication.validation.password-insufficient-special"));
	if (message.includes("illegal_numerical_sequence"))
		return (t("authentication.validation.password-illegal-numerical-sequence"));
	if (message.includes("illegal_alphabetical_sequence"))
		return (t("authentication.validation.password-illegal-alphabetical-sequence"));
	if (message.includes("illegal_word"))
		return (t("authentication.validation.password-illegal-word"));
	if (message.includes("contains_email"))
		return (t("authentication.validation.password-contains-email"));
	if (message.includes("contains_firstname"))
		return (t("authentication.validation.password-contains-firstname"));
	if (message.includes("contains_lastname"))
		return (t("authentication.validation.password-contains-lastname"));
	if (message.includes("contains_history"))
		return (t("authentication.validation.password-contains-history"));

	return t("common.something-went-wrong");
};

export const WebshopSteps = {
    GROUPS: 0,
    PRODUCTS: 1,
    PERSONAL: 2,
    AUTH: 3,
    FINISHED: 4
}